import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VRow,
                [
                  _c("select-simple-unidade", {
                    attrs: {
                      value: _vm.unidade,
                      "mapeamento-id": _vm.diagnostico.mapeamento.id,
                    },
                  }),
                ],
                1
              ),
              _vm.unidade
                ? _c(
                    "div",
                    [
                      _vm.desempenhosUnidadeViabilizados.length
                        ? _c(
                            "div",
                            [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c("pie-chart-categoria-c-d-s", {
                                        attrs: {
                                          "com-sub-piechart": false,
                                          desempenhos:
                                            _vm.desempenhosUnidadeViabilizados,
                                          fonte: _vm.fontePieChart,
                                          titulo: _vm.tituloPieChart,
                                          "is-get-svg": _vm.isGetSvg,
                                        },
                                        on: {
                                          svg: (value) => (_vm.svg = value),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { staticClass: "justify-center" },
                                [_c("legenda-cds")],
                                1
                              ),
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c(VDataTable, {
                                        attrs: {
                                          headers: _vm.tabelaResultado.headers,
                                          items:
                                            _vm.desempenhosUnidadeViabilizadosTabelaResultados,
                                          search:
                                            _vm.tabelaResultado.opcoes.pesquisa,
                                          "sort-by":
                                            _vm.tabelaResultado.opcoes
                                              .ordenarPor,
                                          "sort-desc":
                                            _vm.tabelaResultado.opcoes
                                              .decrescente,
                                          "disable-pagination": "",
                                          "hide-default-footer": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "top",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    VRow,
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _c(
                                                        VToolbar,
                                                        { attrs: { flat: "" } },
                                                        [
                                                          _c(
                                                            VToolbarTitle,
                                                            [
                                                              _c(
                                                                "h2",
                                                                {
                                                                  staticClass:
                                                                    "title primary--text text--darken-1 text-no-wrap",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " RESULTADOS "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    VRow,
                                                    [
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "4",
                                                          },
                                                        },
                                                        [
                                                          _c("app-sort", {
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .tabelaResultado
                                                                  .opcoes,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.tabelaResultado,
                                                                    "opcoes",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "tabelaResultado.opcoes",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "4",
                                                          },
                                                        },
                                                        [
                                                          _c(VSelect, {
                                                            attrs: {
                                                              items:
                                                                _vm.situacoes,
                                                              "item-text":
                                                                "text",
                                                              label:
                                                                "Situação:",
                                                              "prepend-icon":
                                                                "filter_list",
                                                              "return-object":
                                                                "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.situacaoSelecionada,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.situacaoSelecionada =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "situacaoSelecionada",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "4",
                                                          },
                                                        },
                                                        [
                                                          _c("app-search", {
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .tabelaResultado
                                                                  .opcoes,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.tabelaResultado,
                                                                    "opcoes",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "tabelaResultado.opcoes",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: `item.cds`,
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      class:
                                                        item.cds >= 9
                                                          ? "font-weight-bold"
                                                          : "",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.cdsStr)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: `item.naoAtende`,
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: { color: "grey" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.iconNaoAtende
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: `item.emDesenvolvimento`,
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: { color: "grey" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.iconEmDesenvolvimento
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: `item.atende`,
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: { color: "grey" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.iconAtende
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: `body.append`,
                                              fn: function () {
                                                return [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "subtitle-2 grey--text text--darken-2",
                                                          },
                                                          [_vm._v("MÉDIA")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.meanCdsTabelaResultados
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("td"),
                                                    _c("td"),
                                                    _c("td"),
                                                  ]),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "subtitle-2 grey--text text--darken-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "DESVIO PADRÃO"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.stdCdsTabelaResultados
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("td"),
                                                    _c("td"),
                                                    _c("td"),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c("tabela-resultados-c-d-s", {
                                        attrs: {
                                          dados: _vm.dadosTabelaCds,
                                          "is-uma-unidade": "",
                                          titulo: "QUADRO RESUMO DO CDS",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.desempenhosUnidadeInviabilizados.length
                                ? _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        [
                                          _c(VDataTable, {
                                            attrs: {
                                              headers:
                                                _vm.tabelaInviabilizados
                                                  .headers,
                                              items:
                                                _vm.desempenhosUnidadeInviabilizados,
                                              search:
                                                _vm.tabelaInviabilizados.opcoes
                                                  .pesquisa,
                                              "sort-by":
                                                _vm.tabelaInviabilizados.opcoes
                                                  .ordenarPor,
                                              "sort-desc":
                                                _vm.tabelaInviabilizados.opcoes
                                                  .decrescente,
                                              "disable-pagination": "",
                                              "hide-default-footer": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "top",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        VRow,
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            VToolbar,
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VToolbarTitle,
                                                                [
                                                                  _c(
                                                                    "h2",
                                                                    {
                                                                      staticClass:
                                                                        "title primary--text text--darken-1 text-no-wrap",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " CDS INVIABILIZADOS "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VRow,
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                md: "4",
                                                              },
                                                            },
                                                            [
                                                              _c("app-sort", {
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .tabelaInviabilizados
                                                                      .opcoes,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.tabelaInviabilizados,
                                                                        "opcoes",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "tabelaInviabilizados.opcoes",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          _c(VCol),
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                md: "4",
                                                              },
                                                            },
                                                            [
                                                              _c("app-search", {
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .tabelaInviabilizados
                                                                      .opcoes,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.tabelaInviabilizados,
                                                                        "opcoes",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "tabelaInviabilizados.opcoes",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: `item.comportamentalViabilizado`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: {
                                                            color: "grey",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.iconResultadoComportamental
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.tecnicoViabilizado`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: {
                                                            color: "grey",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.iconResultadoTecnico
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VRow,
                                { staticClass: "justify-end mb-1" },
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { "max-width": "400", top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        color: "success",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.getRelatorio()
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("get_app"),
                                                    ]),
                                                    _vm._v(" BAIXAR PDF "),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3286038400
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para baixar o relatório dos dados em formato PDF."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm.unidade.selecionado
                        ? _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                [
                                  _c("app-alert", {
                                    attrs: {
                                      icon: "info",
                                      message: _vm.resultadoInviabilizado,
                                      type: "info",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }